import React, { Component } from 'react';

import './styles/care.scss';

class Care extends Component {
  
  render() {
    return (
      <div className="care">
        <div className="container-inner">
          <div className="care__title">
            <h3>Care symbols<br />decoded</h3>
          </div>
          <div className="care__list">
            <div className="care__list__container">
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-1.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Maximum temperature 40&deg;</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-2.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Maximum temperature 30&deg;</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-3.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Do not use bleach</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-4.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Low temperature drum drying</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-5.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Drying allowed</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-6.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Hang dry only</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-7.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Ironing at&nbsp;a&nbsp;soleplate temperature of&nbsp;up&nbsp;to&nbsp;110&deg;</p>
                  <p>Steaming allowed</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-8.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Ironing at&nbsp;a&nbsp;soleplate temperature of&nbsp;up&nbsp;to&nbsp;150&deg;</p>
                  <p>Steaming allowed</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-9.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Normal mode</p>
                  <p>Cleaning in&nbsp;tetrachlorethylene and any solvents approved for&nbsp;F</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-10.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Dry clean only</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-11.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Normal mode</p>
                  <p>Dry cleaning in&nbsp;hydrocarbons from 150&deg; to&nbsp;210&deg;</p>
                </div>
              </div>
              <div className="care__list__item">
                <div className="care__list__item__icon">
                  <img src={require('../../static/images/care/icon-12.svg').default} alt="" />
                </div>
                <div className="care__list__item__title">
                  <p>Branding</p>
                  <p>Wash inside out and do&nbsp;not heat branding elements</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Care;